import { Box, TextField, Button, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import pallet from '../../../layouts/pallet';

const PaperWrapper = styled(Box)(() => ({
  marginTop: 16,
  maxWidth: '95%',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 16,
  backgroundColor: pallet.N0,
  borderRadius: 8,
  boxShadow: `0px 3px 8px 0px ${pallet.boxShadow}`,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  minHeight: 'auto',
  boxSizing: 'border-box'
}));

const ControlsRow = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 16px;
  justify-content: space-between;
`;

const FileInputField = styled(TextField)`
  width: 70%;
  & .MuiOutlinedInput-root {
    width: 100%;
    padding-right: 0 !important;
    & .MuiOutlinedInput-input {
      cursor: pointer;
    }
  }
`;

const UploadButton = styled(Button)`
  white-space: nowrap;
  height: 40px;
`;

const CancelIcon = styled(IconButton)({
  width: '30px',
  '&:hover': {
    background: 'none'
  }
});

const ChooseFileButton = styled(Button)<{ isFileName?: boolean }>(
  ({ isFileName }) => ({
    position: 'relative',
    border: `1px solid ${pallet.fileUploadBox} !important`,
    color: pallet.formLabelText,
    borderRadius: '8px !important',
    textTransform: 'none',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    padding: '6px 12px',
    background: 'transparent',
    gap: '8px',
    justifyContent: isFileName ? 'space-between' : 'center',
    height: '48px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '512px !important',
    width: '100%',

    '& .MuiButton-startIcon': {
      marginRight: '8px'
    }
  })
);

const ChooseFileButtonWrapper = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: '8px'
});

const UploadProgressWrapper = styled(Box)({
  width: '100%',
  height: '6px',
  backgroundColor: pallet.progressBackground,
  position: 'absolute',
  top: 0,
  left: 0
});

const UploadProgress = styled(Box)<{ uploadProgress: number }>(
  ({ uploadProgress }) => ({
    height: '6px',
    width: `${uploadProgress}%`,
    backgroundColor: pallet.uploadProgress,
    borderRadius: '100px'
  })
);

const HelperTextWrapper = styled(Typography)({
  fontSize: '14px',
  color: `${pallet.lightBlueText}`,
  width: '292px',
  fontWeight: '400px'
});

export {
  PaperWrapper,
  ControlsRow,
  FileInputField,
  UploadButton,
  CancelIcon,
  ChooseFileButton,
  ChooseFileButtonWrapper,
  UploadProgressWrapper,
  UploadProgress,
  HelperTextWrapper
};
